<div class="container-fluid">
  <div class="row">
    <div class="col-md-2 col-lg-3"></div>
    <div class="col-sm-12 col-md-8 col-lg-6">
      <div class="jumbotron">
        <div class="garanti-xl-logo garanti-xl-logo-small text-center">
          <img src="assets/img/garanti-portal-logo.png" />
        </div>
        <div class="frontpage-text text-center">
          <p class="h4">Kunde inte hitta den begärda sidan!</p>
          <p class="h2">&ldquo;{{ url }}&rdquo;</p>
        </div>
      </div>
    </div>
  </div>
</div>
